import styled from "styled-components";
import { ButtonSection } from "../Payment/PaymentStyledComponents";
import { TextBold } from "../../styles/GlobalStyledComponents";

interface PaymentProps {
  responsiveHidden?: boolean;
}

export const TpvSection = styled.div`
      width: 100%;
    display: flex
;
    flex-direction: column;
    -webkit-box-align: center;
    align-items: center;
  /* height: 100%; */
  /* display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center; */
`;

export const TpvWrapper = styled.div`
  width: 100%;
  min-height: 450px;
    display: flex;
    flex-direction: column;
    -webkit-box-align: center;
    align-items: center; 
`;

export const TpvHeader = styled.div`
    height: 100%;
    background-color: ${props => props.theme.colors.white};
    padding: 24px;
    border-radius: 16px;
    box-shadow: 0px 0px 16px rgba(8, 84, 117, 0.08);
    align-items: center;
    max-width: 700px;
    width: 100%;

    @media (min-width: 601px) and (max-width: 650px) {
        width: 93%;
        margin: auto;
    }
`;
export const TpvHeaderTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 8px;
  gap: 8px;
`;

export const TpvMoneyWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
  flex-direction: row;
  gap: 8px;
`;

export const TpvDescriptionSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TpvPriceText = styled(TextBold)``;

export const TpvButtonSection = styled(ButtonSection)`
    justify-content: flex-start;
    padding: 16px 0px 24px;
    
    @media (max-width: 850px) {
      max-width: 100%;
    }

    @media (max-width: 650px) {
      padding: 0px;
    }
`;
export const ButtonTpvWrapper = styled.div`
    width: 65%;
    justify-content: center;
    @media (max-width: 600px) {
       width: 100%;
       padding: 0;
    }
`;

export const PaymentIcon = styled.img<PaymentProps>`
    margin-right: 5px;

    @media (max-width: 500px) {
        display: ${props => props.responsiveHidden ? 'none' : 'initial'};
    }
`;

export const PepperTpvContainer = styled.div`
    padding: 12px 25px;
    -webkit-box-align: center;
    border-radius: 8px;
    width: 100%;
    max-width: 700px;
    margin-top: 16px;
    display: flex;
    z-index: 99;
    background-color: #fff;
    flex-direction: column;
    align-items: center;
    min-height: 450px;
   @media (max-width: 950px) {
    padding: 12px 0px;
   }
    
    @media (max-width: 650px) {
      width: 93%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 auto;
      margin-top: 10px;
      padding: 12px 0px;
    }
`;